import React from 'react';
import {IssueDetails, ServiceDetails} from "~/types";
import classes from './style.module.scss';
import useTranslation from "~/app/hooks/useTranslation";
import List from "./List";
import { IssueOrServiceType } from '~/app/data/statuses/chat';

export interface WorkOrderProps {
    status: IssueDetails['status'] | ServiceDetails['status']
    workOrderNo: IssueDetails['workOrderNo'] | ServiceDetails['workOrderNo']
    workDetails: IssueDetails['workDetails'] | ServiceDetails['workDetails']
    type: IssueOrServiceType
}

export type WorkOrderComponent = React.FC<WorkOrderProps>

const WorkOrder: WorkOrderComponent = ({status, workOrderNo, workDetails, type}) => {
    const { t } = useTranslation(type === IssueOrServiceType.ISSUE ? 'issue': 'service');

    return (
        <div className={classes['work-info']}>
            <div className={classes['order-number']}>
                <span className={classes['title']}>{t('workorder')}</span>
                <span className={classes['number']}>{workOrderNo}</span>
            </div>
            {workDetails.map((details, index) => <List status={status} workDetails={details} key={index} type={type}/>)}
            <hr className={classes['bottom-line']}/>
        </div>
    );
};

export default WorkOrder
